import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import CustomModal from '../../../../../modal/CustomModal'
import Button from '../../../../../buttons/Button'
import CircleLoader from '../../../../../loaders/CircleLoader'
import MainIcon from '../../../../../../../img/svg/main'
import { markOrderReadyThunk } from '../../../../../../../redux/thunk/wolt/orders'
import { MarkReadyOrderModalErrorRow, MarkReadyOrderModalSuccessWrapper, MarkReadyOrderModalText, MarkReadyOrderModalWrapper } from './index.styled'
import Portal from '../../../../../Portal'

const EVENT_Z_INDEX = 1
const RETURN_EVENT_Z_INDEX = 0

const MarkReadyOrderModal = React.memo(({ isOpen, close, order }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [markReadyStatus, setMarkReadyStatus] = useState(null)
	const isPending = markReadyStatus === 'pending'
	const isSucceeded = markReadyStatus === 'succeeded'
	const isError = markReadyStatus === 'error'

	const handleClose = useCallback(() => {
		setMarkReadyStatus(null)
		close()
	}, [close])

	const handleAccept = useCallback(async () => {
		setMarkReadyStatus('pending')
		const isMarkedReady = await dispatch(markOrderReadyThunk(order?.orderId))
		setMarkReadyStatus(isMarkedReady ? 'succeeded' : 'error')
	}, [dispatch, order?.orderId])

	const stopClickPropagation = useCallback((e) => {
		e.stopPropagation()
	}, [])

	return (
		<Portal containerId="content">
			<MarkReadyOrderModalWrapper onClick={stopClickPropagation} onDoubleClick={stopClickPropagation}>
				<CustomModal isOpen={isOpen}
				             close={handleClose}
				             id="mark-ready-order-modal"
				             size="small"
				             title={t('order.modal.mark_ready_title')}
				             disableBackButton={true}
				             zIndex={EVENT_Z_INDEX}
				             returnZIndex={RETURN_EVENT_Z_INDEX}
				             footerClassname="big-top"
				             button={
											 isSucceeded ?
												 <Button name="cancel" icon="clear" text={t('buttons.controls.cancel_1')}
						                     keyButton="Escape" keyText="esc" zIndex={EVENT_Z_INDEX}
						                     onClick={handleClose} className="btn-center" /> :
												 <Button name="accept" icon={!isPending && 'checkmark'} color="green"
						                     text={t('order.modal.mark_ready')}
						                     keyButton="F2" zIndex={EVENT_Z_INDEX}
						                     onClick={handleAccept} disabled={isPending} className="btn-center">
													 {isPending && <CircleLoader />}
												 </Button>}>
					{isSucceeded ?
						<MarkReadyOrderModalSuccessWrapper>
							<MainIcon icon="green-circle-checkmark" />
							<MarkReadyOrderModalText>{t('order.modal.mark_ready_done')}</MarkReadyOrderModalText>
						</MarkReadyOrderModalSuccessWrapper> :
						<>
							<MarkReadyOrderModalText>{t('order.modal.mark_ready_question')}</MarkReadyOrderModalText>
							{isError &&
								<MarkReadyOrderModalErrorRow>
									<MainIcon icon="error" />
									{t('order.modal.mark_ready_error')}
								</MarkReadyOrderModalErrorRow>}
						</>}
				</CustomModal>
			</MarkReadyOrderModalWrapper>
		</Portal>
	)
})

MarkReadyOrderModal.displayName = 'MarkReadyOrderModal'
export default MarkReadyOrderModal
